import { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

const COOKIE_KEY = 'device_id';
const COOKIE_EXPIRY_DAYS = 365; // 1 year

export default function useDeviceId() {
  const [deviceId, setDeviceId] = useState('');

  useEffect(() => {
    let id = Cookies.get(COOKIE_KEY);

    if (!id) {
      id = uuidv4();
      Cookies.set(COOKIE_KEY, id, { expires: COOKIE_EXPIRY_DAYS, secure: true, samesite: 'strict' });
    }
    setDeviceId(id);
  }, []);

  return deviceId;
}
